import { buildQuery, queryParams } from "helpers/reqparams";
import { Filter, OrderBy } from "odata-query";
import { alertRequest, body, request } from "services/request";

const resource = "api/tripPlanning";

export const getReport = (
    params: { length: number; start: number; orderBy?: OrderBy<{}>; filter: Filter<{}> },
    queryP: {},
) => {
    const qp = queryParams(queryP);
    const odataQuery = buildQuery({
        top: params.length,
        skip: params.start,
        filter: params.filter,
        ...(params.orderBy ? { orderBy: params.orderBy } : {}),
    }).substring(1);

    const query = [qp, odataQuery].join("&");
    return request(`${resource}/getReport${query}`, { method: "GET" });
};

export const getTripPlanning = (bidId: number, carId: number) =>
    request(`${resource}/getCarTripPlanning?bidId=${bidId}&carId=${carId}`, { method: "GET" });
export const getResponsibles = () => request(`${resource}/getResponsibles`, { method: "GET" });
export const resetCache = () => request(`${resource}/resetCache`, body({}));
export const applyColumnDispatcher = (params: {}) => alertRequest(`${resource}/applyColumnDispatcher`, body(params));
export const applyCarMechanic = (params: {}) => alertRequest(`${resource}/applyCarMechanic`, body(params));
